import React, { useState, useEffect } from "react";
import {toast} from "react-toastify";
import {Form} from 'react-bootstrap';
import UserService from "services/user.service";

const AppointmentReminder = ({ initialAppointmentReminderEmailEnabled, isReadOnly=false }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isToggling, setIsToggling] = useState(false);
  
  useEffect(() => {
    setIsEnabled(initialAppointmentReminderEmailEnabled || false);
  }, [initialAppointmentReminderEmailEnabled]);

  const handleToggle = async () => {
    const newValue = !isEnabled;
    setIsToggling(true);

    try{
      const data = await UserService.reminderSettings({ appointment_email_reminder: newValue });
      setIsEnabled(data.appointment_email_reminder);
    } catch (error) {
      toast.error("Something went wrong! Please try again later.")
    } finally {
      setIsToggling(false);
    }
  };
   return (
    <div className="profile-info-group mb-6 mt-6">
      <div className= "profile-info-row">
        <div className= "profile-info-label flex-grow-1">
          <p className="mb-0">Appointment reminder - email</p>
        </div>
        <Form.Check
          type="switch"
          id="appointment-email-reminder-switch"
          label=""
          checked={isEnabled}
          onChange={handleToggle}
          disabled={isReadOnly || isToggling}
          className="ml-4 switch-toggle"
          style={{ transform: 'scale(1.5)'}}
        />
      </div>
    </div>
  );
};

export default AppointmentReminder;